module.exports = __webpack_public_path__ + "static/GPmain3-8aba3bd83e08a5c00837a5abadf98fd5.png";